import { EMPTY_LIST } from '../../../../../constants/common'
import { getListingPublishBlockReason } from '../../../../RentalPortalListing'

export function getListingStatusActionErrorText({ error, t }) {
  const missingItems = error?.response?.data?.missing ?? EMPTY_LIST

  return missingItems.length > 0
    ? getListingPublishBlockReason({
        missingItems: missingItems.map(item => t(item)),
        t,
      })
    : t('RentalPortal.ListingStatusChangeErrorKey')
}
